import React, { FC } from 'react';
import { Select, SelectProps } from '@rentacenter/racstrap';
import { Controller, useFormContext } from 'react-hook-form';

import { TaskPriority } from '../../../../domain/Task/Task';
import {
  getEmptyValidationMessage,
  TaskFormFields
} from '../../CreateTask/CreateTask';
import { buildOptions } from '../../../../utils/buildOptions';

export const TaskPrioritySelect: FC<Partial<SelectProps>> = props => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={TaskFormFields.priority}
      rules={{ required: true }}
      render={({ ref, ...rest }, { invalid }) => (
        <Select
          options={buildOptions(TaskPriority)}
          required={true}
          errorMessage={getEmptyValidationMessage(invalid)}
          label="Priority"
          placeholder="Select"
          size="large"
          {...rest}
          {...props}
        />
      )}
    />
  );
};
